(function () {
  var STORAGE_KEY = 'ccObjectiveStandardsV1';
  var LEVELS = ['Building', 'Beginner', 'Novice', 'Intermediate', 'Advanced', 'Elite'];
  var RUN_AGES = [15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90];

  var strengthStandards = {
    squat: {
      male: [
        [64, 93, 130, 173, 219],
        [62, 90, 124, 165, 208],
        [60, 87, 118, 157, 197],
        [57, 83, 111, 148, 184],
        [54, 79, 104, 139, 171],
        [50, 73, 95, 126, 154]
      ],
      female: [
        [38, 58, 73, 98, 126],
        [37, 55, 69, 93, 119],
        [35, 52, 65, 88, 112],
        [33, 49, 61, 82, 104],
        [31, 45, 56, 76, 96],
        [28, 41, 50, 69, 85]
      ]
    },
    deadlift: {
      male: [
        [78, 112, 152, 196, 247],
        [75, 108, 146, 188, 236],
        [72, 103, 139, 179, 223],
        [68, 98, 131, 168, 209],
        [64, 92, 123, 157, 194],
        [59, 85, 112, 143, 175]
      ],
      female: [
        [38, 60, 87, 111, 150],
        [36, 57, 82, 105, 142],
        [34, 54, 77, 99, 134],
        [32, 50, 72, 92, 124],
        [30, 46, 66, 85, 114],
        [27, 42, 59, 76, 101]
      ]
    },
    bench: {
      male: [
        [47, 70, 98, 132, 169],
        [45, 67, 94, 126, 161],
        [43, 64, 89, 120, 152],
        [41, 60, 84, 113, 142],
        [38, 56, 78, 105, 132],
        [35, 51, 71, 95, 119]
      ],
      female: [
        [17, 31, 51, 74, 101],
        [16, 29, 48, 70, 95],
        [15, 27, 45, 66, 89],
        [14, 25, 42, 61, 82],
        [13, 23, 38, 56, 75],
        [12, 20, 34, 50, 66]
      ]
    }
  };

  var bodyweightStandards = {
    pressups: {
      male: [0, 15, 25, 35, 45],
      female: [0, 8, 15, 25, 30]
    },
    situps: {
      male: [0, 20, 30, 40, 50],
      female: [0, 15, 25, 35, 45]
    },
    pullups: {
      male: [0, null, 5, 10, 14],
      female: [0, null, 2, 6, 9]
    }
  };

  var runStandards = {
    mile: {
      male: [
        ['09:45', '08:05', '06:51', '05:58', '05:19'],
        ['09:25', '07:48', '06:38', '05:46', '05:08'],
        ['09:25', '07:48', '06:38', '05:46', '05:08'],
        ['09:26', '07:49', '06:38', '05:46', '05:09'],
        ['09:35', '07:56', '06:44', '05:52', '05:14'],
        ['09:55', '08:13', '06:58', '06:04', '05:25'],
        ['10:17', '08:31', '07:14', '06:18', '05:37'],
        ['10:42', '08:51', '07:31', '06:33', '05:50'],
        ['11:08', '09:13', '07:49', '06:49', '06:04'],
        ['11:36', '09:37', '08:09', '07:06', '06:20'],
        ['12:07', '10:02', '08:31', '07:25', '06:37'],
        ['12:43', '10:32', '08:57', '07:47', '06:57'],
        ['13:40', '11:20', '09:37', '08:22', '07:28'],
        ['15:08', '12:32', '10:38', '09:16', '08:15'],
        ['17:25', '14:26', '12:15', '10:40', '09:30'],
        ['21:13', '17:35', '14:55', '12:59', '11:35']
      ],
      female: [
        ['11:12', '09:27', '08:08', '07:08', '06:24'],
        ['10:40', '09:00', '07:44', '06:48', '06:06'],
        ['10:40', '09:00', '07:44', '06:48', '06:06'],
        ['10:40', '09:00', '07:44', '06:48', '06:06'],
        ['10:44', '09:04', '07:47', '06:50', '06:08'],
        ['10:58', '09:15', '07:57', '06:59', '06:16'],
        ['11:21', '09:35', '08:14', '07:14', '06:29'],
        ['11:56', '10:04', '08:40', '07:36', '06:49'],
        ['12:37', '10:39', '09:10', '08:02', '07:13'],
        ['13:24', '11:18', '09:43', '08:32', '07:39'],
        ['14:16', '12:02', '10:21', '09:05', '08:09'],
        ['15:15', '12:52', '11:04', '09:43', '08:43'],
        ['16:23', '13:50', '11:53', '10:26', '09:22'],
        ['17:45', '14:58', '12:52', '11:18', '10:08'],
        ['19:59', '16:52', '14:30', '12:43', '11:25'],
        ['24:05', '20:19', '17:28', '15:20', '13:45']
      ]
    },
    run5k: {
      male: [
        ['32:35', '27:14', '23:19', '20:25', '18:17'],
        ['31:29', '26:19', '22:31', '19:44', '17:40'],
        ['31:29', '26:19', '22:31', '19:44', '17:40'],
        ['31:29', '26:19', '22:32', '19:44', '17:40'],
        ['31:59', '26:45', '22:53', '20:03', '17:57'],
        ['33:09', '27:43', '23:43', '20:46', '18:36'],
        ['34:25', '28:47', '24:38', '21:34', '19:19'],
        ['35:47', '29:55', '25:36', '22:26', '20:05'],
        ['37:16', '31:10', '26:40', '23:21', '20:55'],
        ['38:53', '32:31', '27:49', '24:22', '21:49'],
        ['40:38', '33:59', '29:05', '25:28', '22:48'],
        ['42:43', '35:43', '30:34', '26:46', '23:58'],
        ['45:55', '38:23', '32:51', '28:46', '25:46'],
        ['50:49', '42:30', '36:22', '31:51', '28:31'],
        ['58:28', '48:53', '41:50', '36:38', '32:48'],
        ['01:11:08', '59:29', '50:54', '44:35', '39:55']
      ],
      female: [
        ['37:14', '31:40', '27:26', '24:14', '21:50'],
        ['35:27', '30:08', '26:07', '23:04', '20:47'],
        ['35:27', '30:08', '26:07', '23:04', '20:47'],
        ['35:27', '30:08', '26:07', '23:04', '20:47'],
        ['35:40', '30:20', '26:17', '23:13', '20:56'],
        ['36:25', '30:58', '26:49', '23:42', '21:22'],
        ['37:43', '32:04', '27:47', '24:33', '22:07'],
        ['39:39', '33:43', '29:13', '25:49', '23:16'],
        ['41:56', '35:40', '30:54', '27:18', '24:36'],
        ['44:29', '37:50', '32:47', '28:58', '26:06'],
        ['47:23', '40:18', '34:54', '30:51', '27:48'],
        ['50:40', '43:05', '37:20', '32:59', '29:43'],
        ['54:27', '46:18', '40:07', '35:27', '31:56'],
        ['58:57', '50:07', '43:25', '38:22', '34:35'],
        ['01:06:22', '56:26', '48:54', '43:12', '38:56'],
        ['01:19:59', '01:08:01', '58:55', '52:04', '46:55']
      ]
    },
    run10k: {
      male: [
        ['01:07:39', '56:28', '48:15', '42:15', '37:51'],
        ['01:05:30', '54:39', '46:43', '40:54', '36:38'],
        ['01:05:30', '54:39', '46:23', '40:54', '36:38'],
        ['01:05:30', '54:39', '46:43', '40:54', '36:38'],
        ['01:06:06', '55:09', '47:09', '41:16', '36:58'],
        ['01:07:58', '56:43', '48:29', '42:26', '38:01'],
        ['01:10:43', '59:01', '50:26', '44:10', '39:33'],
        ['01:13:48', '01:01:30', '52:34', '46:01', '41:14'],
        ['01:16:57', '01:04:13', '54:43', '48:03', '43:03'],
        ['01:20:30', '01:07:11', '57:25', '50:16', '45:02'],
        ['01:24:23', '01:10:25', '01:00:11', '52:42', '47:12'],
        ['01:28:40', '01:14:00', '01:03:15', '55:22', '49:36'],
        ['01:34:32', '01:18:53', '01:07:26', '59:02', '52:53'],
        ['01:43:56', '01:26:45', '01:14:08', '01:04:54', '58:08'],
        ['01:58:54', '01:39:14', '01:24:49', '01:14:15', '01:06:31'],
        ['02:24:04', '02:00:14', '01:42:45', '01:29:58', '01:20:35']
      ],
      female: [
        ['01:18:52', '01:06:58', '57:55', '51:07', '46:03'],
        ['01:13:58', '01:02:48', '54:19', '47:57', '43:12'],
        ['01:13:49', '01:02:40', '54:13', '47:51', '43:06'],
        ['01:13:58', '01:02:40', '54:19', '47:57', '43:12'],
        ['01:14:53', '01:03:35', '55:00', '48:33', '43:44'],
        ['01:16:43', '01:05:08', '56:20', '49:44', '44:48'],
        ['01:19:34', '01:07:33', '58:26', '51:35', '46:28'],
        ['01:23:41', '01:11:03', '01:01:27', '54:15', '48:52'],
        ['01:28:40', '01:15:17', '01:05:07', '57:29', '51:47'],
        ['01:34:18', '01:20:04', '01:09:15', '01:01:28', '55:04'],
        ['01:40:42', '01:25:30', '01:13:57', '01:05:16', '58:48'],
        ['01:48:01', '01:31:43', '01:19:20', '01:10:01', '01:03:05'],
        ['01:56:29', '01:38:54', '01:25:33', '01:15:31', '01:08:01'],
        ['02:08:29', '01:49:06', '01:34:22', '01:23:18', '01:15:02'],
        ['02:28:44', '02:06:17', '01:49:14', '01:36:25', '01:26:51'],
        ['03:04:58', '02:37:02', '02:15:50', '01:59:54', '01:48:00']
      ]
    }
  };

  var metricLabels = {
    squat: 'Back squat',
    deadlift: 'Deadlift',
    bench: 'Bench press',
    pressups: 'Press ups',
    situps: 'Sit ups',
    pullups: 'Pull ups',
    mile: '1 mile run',
    run5k: '5km run',
    run10k: '10km run'
  };

  function parseTime(value) {
    var parts = String(value || '').trim().split(':');
    if (parts.length < 2 || parts.length > 3) return NaN;
    var numbers = parts.map(Number);
    if (numbers.some(function (part) { return !Number.isFinite(part) || part < 0; })) return NaN;
    if (numbers[numbers.length - 1] >= 60 || (parts.length === 3 && numbers[1] >= 60)) return NaN;
    if (parts.length === 2) return numbers[0] * 60 + numbers[1];
    return numbers[0] * 3600 + numbers[1] * 60 + numbers[2];
  }

  function strengthBand(age) {
    if (age <= 29) return 0;
    if (age <= 34) return 1;
    if (age <= 39) return 2;
    if (age <= 44) return 3;
    if (age <= 49) return 4;
    return 5;
  }

  function nearestRunAgeIndex(age) {
    var bestIndex = 0;
    var bestDistance = Math.abs(age - RUN_AGES[0]);
    for (var i = 1; i < RUN_AGES.length; i += 1) {
      var distance = Math.abs(age - RUN_AGES[i]);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = i;
      }
    }
    return bestIndex;
  }

  function scoreIncreasing(value, thresholds, unit) {
    var points = 0;
    for (var i = 0; i < thresholds.length; i += 1) {
      if (thresholds[i] !== null && value >= thresholds[i]) points = i + 1;
    }
    var nextIndex = points;
    while (nextIndex < thresholds.length && thresholds[nextIndex] === null) nextIndex += 1;
    return {
      points: points,
      level: LEVELS[points],
      next: nextIndex < thresholds.length
        ? thresholds[nextIndex] + ' ' + unit + ' reaches ' + LEVELS[nextIndex + 1]
        : 'Elite standard reached. Retest and defend it.'
    };
  }

  function scoreRun(value, thresholds, comparisonAge) {
    var seconds = parseTime(value);
    if (!Number.isFinite(seconds)) return { invalid: true };
    var points = 0;
    for (var i = 0; i < thresholds.length; i += 1) {
      if (seconds <= parseTime(thresholds[i])) points = i + 1;
    }
    return {
      points: points,
      level: LEVELS[points],
      next: points < thresholds.length
        ? thresholds[points] + ' or faster reaches ' + LEVELS[points + 1] + ' (age ' + comparisonAge + ' benchmark)'
        : 'Elite standard reached. Retest and defend it.'
    };
  }

  function scoreMetric(metric, rawValue, sex, age) {
    if (rawValue === '') return null;
    if (strengthStandards[metric]) {
      var weight = Number(rawValue);
      if (!Number.isFinite(weight) || weight < 0) return { invalid: true };
      return scoreIncreasing(weight, strengthStandards[metric][sex][strengthBand(age)], 'kg');
    }
    if (bodyweightStandards[metric]) {
      var reps = Number(rawValue);
      if (!Number.isFinite(reps) || reps < 0) return { invalid: true };
      return scoreIncreasing(reps, bodyweightStandards[metric][sex], 'reps');
    }
    var runAgeIndex = nearestRunAgeIndex(age);
    return scoreRun(rawValue, runStandards[metric][sex][runAgeIndex], RUN_AGES[runAgeIndex]);
  }

  function updateTrack(track, points) {
    if (!track) return;
    Array.prototype.forEach.call(track.children, function (segment, index) {
      segment.toggleAttribute('data-active', index < points);
    });
  }

  function safeStorageRead() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function safeStorageWrite(value) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (error) {
      return;
    }
  }

  function init(checker) {
    if (!checker || checker.hasAttribute('data-cc-ready')) return;
    checker.setAttribute('data-cc-ready', 'true');

    var ageInput = checker.querySelector('[data-objective-age]');
    var sexInputs = checker.querySelectorAll('[name="objective-sex"]');
    var metricInputs = checker.querySelectorAll('[data-standard-input]');
    var scoreNode = checker.querySelector('[data-objective-score]');
    var countNode = checker.querySelector('[data-objective-count]');
    var overallNode = checker.querySelector('[data-objective-level]');
    var progressNode = checker.querySelector('[data-objective-progress]');
    var nextNode = checker.querySelector('[data-objective-next]');
    var resetButton = checker.querySelector('[data-objective-reset]');

    function getSex() {
      var selected = checker.querySelector('[name="objective-sex"]:checked');
      return selected ? selected.value : 'male';
    }

    function save() {
      var values = {};
      Array.prototype.forEach.call(metricInputs, function (input) {
        values[input.getAttribute('data-standard-input')] = input.value;
      });
      safeStorageWrite({
        age: ageInput.value,
        sex: getSex(),
        values: values
      });
    }

    function render() {
      var age = Math.min(90, Math.max(15, Number(ageInput.value) || 30));
      var sex = getSex();
      var results = [];
      var score = 0;

      Array.prototype.forEach.call(metricInputs, function (input) {
        var metric = input.getAttribute('data-standard-input');
        var rawValue = input.value.trim();
        var result = scoreMetric(metric, rawValue, sex, age);
        var levelNode = checker.querySelector('[data-level-for="' + metric + '"]');
        var targetNode = checker.querySelector('[data-target-for="' + metric + '"]');
        var trackNode = checker.querySelector('[data-track-for="' + metric + '"]');

        levelNode.className = 'cc-benchmark__level';
        if (!result) {
          levelNode.textContent = 'Not scored';
          targetNode.textContent = 'Enter your current result';
          updateTrack(trackNode, 0);
          return;
        }
        if (result.invalid) {
          levelNode.textContent = 'Check entry';
          levelNode.classList.add('is-invalid');
          targetNode.textContent = input.getAttribute('data-time-input') !== null
            ? 'Use MM:SS or H:MM:SS'
            : 'Enter a valid score';
          updateTrack(trackNode, 0);
          return;
        }

        result.metric = metric;
        results.push(result);
        score += result.points;
        levelNode.textContent = result.level;
        levelNode.classList.add('level-' + result.level.toLowerCase());
        targetNode.textContent = result.next;
        updateTrack(trackNode, result.points);
      });

      scoreNode.textContent = score + ' / 45';
      countNode.textContent = results.length + ' of 9 scored';
      progressNode.style.width = Math.round((score / 45) * 100) + '%';

      if (results.length < 9) {
        overallNode.textContent = 'Not ranked';
        nextNode.innerHTML = '<strong>Complete your baseline.</strong><span>Score the remaining ' + (9 - results.length) + ' standard' + (results.length === 8 ? '' : 's') + ' to unlock your overall level.</span>';
      } else {
        var overallPoints = Math.floor(score / 9);
        overallNode.textContent = LEVELS[overallPoints];
        var lowest = results.reduce(function (current, result) {
          return result.points < current.points ? result : current;
        });
        if (lowest.points === 5) {
          nextNode.innerHTML = '<strong>Elite across all nine.</strong><span>Retest regularly and defend the standard.</span>';
        } else {
          nextNode.innerHTML = '<strong>Next objective: ' + metricLabels[lowest.metric] + '.</strong><span>' + lowest.next + '.</span>';
        }
      }
    }

    var saved = safeStorageRead();
    if (saved) {
      if (saved.age) ageInput.value = saved.age;
      if (saved.sex) {
        var savedSex = checker.querySelector('[name="objective-sex"][value="' + saved.sex + '"]');
        if (savedSex) savedSex.checked = true;
      }
      if (saved.values) {
        Array.prototype.forEach.call(metricInputs, function (input) {
          var metric = input.getAttribute('data-standard-input');
          if (Object.prototype.hasOwnProperty.call(saved.values, metric)) input.value = saved.values[metric];
        });
      }
    }

    ageInput.addEventListener('input', function () {
      render();
      save();
    });
    Array.prototype.forEach.call(sexInputs, function (input) {
      input.addEventListener('change', function () {
        render();
        save();
      });
    });
    Array.prototype.forEach.call(metricInputs, function (input) {
      input.addEventListener('input', function () {
        render();
        save();
      });
    });
    resetButton.addEventListener('click', function () {
      ageInput.value = 30;
      var maleInput = checker.querySelector('[name="objective-sex"][value="male"]');
      if (maleInput) maleInput.checked = true;
      Array.prototype.forEach.call(metricInputs, function (input) { input.value = ''; });
      try { localStorage.removeItem(STORAGE_KEY); } catch (error) { /* No action needed. */ }
      render();
    });

    render();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-objective-checker]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
